module.exports = __webpack_public_path__ + "img/archive_black.e72df72b.svg";